import {makeAutoObservable} from "mobx";
import {ITimelineItemDto, RMA_EXTERNAL_TRANSACTION_STATUS, TIMELINE_ITEM_TYPE_ENUM, IClassifiedError, IRmaError} from "../rma-types";
import {rootContainer, TYPE} from "../../../../services/container/root";
import TroubleshootingService from "../../../../services/api/troubleshooting-service";

class TimelineItemStore {
    private _model: ITimelineItemDto = {} as ITimelineItemDto;
    constructor(model: ITimelineItemDto) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: ITimelineItemDto){
        this._model = model;
    }
    
    public get type(): TIMELINE_ITEM_TYPE_ENUM { return this._model.type; }
    public get content(): string { return this._model.content; }
    public get isSystem(): boolean { return this._model.is_system; }
    public get isAutomation(): boolean { return this._model.is_automation; }
    public get userName(): string { return this._model.user_name; }
    public get createdAt(): string { return this._model.created_at; }
    public get platform(): string { return this._model.transaction_data?.platform ?? ''; }
    public get status(): RMA_EXTERNAL_TRANSACTION_STATUS | undefined { return this._model.transaction_data?.status; }
    public get transactionId(): number | undefined { return this._model.transaction_data?.transaction_id; }
    public get returnError(): IRmaError | null { return this._model.return_error; }
    public async generateLogsUrl(rmaId: number): Promise<void> {
        try {
            const troubleshootingService = rootContainer.get<TroubleshootingService>(TYPE.TroubleshootingService);
            const filters: Record<string, string> = {};
            
            // Add available filters based on what we have
            filters.rma_id = rmaId.toString();
            // Note: case_id and order_id would need to be added to TimelineItemStore if available
            
            /** Create Date object only for time calculations */
            const createdAtDate = new Date(this.createdAt);
            const startTime = new Date(createdAtDate.getTime() - 60000); /** -1 minute */
            const endTime = new Date(createdAtDate.getTime() + 60000); /** +1 minute */
            const url = await troubleshootingService.generateLogsPageUrl(
                startTime.toISOString().slice(0, -5) + 'Z',
                endTime.toISOString().slice(0, -5) + 'Z',
                filters,
            );
            
            console.info('Opening logs URL:', url);
            
            // Open in new tab
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.error('Failed to generate logs URL:', error);
        }
    }
}

export { TimelineItemStore as default };
